var materea_t=window.materea_t||(window.materea_t=function(k,v){var d=window.materea_texte;if(!d){try{d=JSON.parse(document.getElementById('materea-i18n').textContent)}catch(e){d={}}window.materea_texte=d}var s=d[k];if(s==null)return k;return v?s.replace(/\{(\w+)\}/g,function(m,n){return n in v?v[n]:m}):s});
(function(){
  var p = new URLSearchParams(location.search);
  if (p.get('static') === '1') { document.documentElement.classList.add('static'); return; }
  if (!('IntersectionObserver' in window)) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('anim');
  

  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      io.unobserve(e.target);
    });
  }, {threshold:0, rootMargin:'0px 0px -15% 0px'});
  document.querySelectorAll('.pdsec').forEach(function(s){ io.observe(s); });
})();



(function(){
  var main = document.getElementById('pd-gal-img');
  var leiste = document.querySelector('.pd-thumbs');
  var thumbs = [].slice.call(document.querySelectorAll('.pd-thumb'));
  var zurueck = document.getElementById('pd-gal-zurueck');
  var vor = document.getElementById('pd-gal-vor');
  var zaehler = document.getElementById('pd-gal-zaehler');
  if (!main) return;
  var i = 0;

  function zeige(n){
    if (n < 0 || n >= thumbs.length) return;
    i = n;
    var t = thumbs[i];
    

    if (t.dataset.srcset) { main.srcset = t.dataset.srcset; }
    else { main.removeAttribute('srcset'); }
    main.src = t.dataset.src;
    main.alt = t.dataset.alt;
    main.style.objectPosition = t.dataset.pos || '';
     
    main.classList.add('wechselt');
    if (main.complete) { main.classList.remove('wechselt'); }
    else { main.addEventListener('load', function ab(){ main.classList.remove('wechselt'); main.removeEventListener('load', ab); }); }
    thumbs.forEach(function(o){ o.removeAttribute('aria-current'); });
    t.setAttribute('aria-current','true');
    t.scrollIntoView({block:'nearest', inline:'nearest'});
    if (zaehler) zaehler.textContent = (i + 1) + ' / ' + thumbs.length;
    if (zurueck) zurueck.disabled = (i === 0);
    if (vor) vor.disabled = (i === thumbs.length - 1);
  }

  thumbs.forEach(function(t, n){
    t.addEventListener('click', function(){
      if (t.classList.contains('pd-thumb-mehr') && leiste && !leiste.classList.contains('alle')){
        leiste.classList.add('alle');
        return;
      }
      zeige(n);
    });
  });
  if (zurueck) zurueck.addEventListener('click', function(){ zeige(i - 1); });
  if (vor) vor.addEventListener('click', function(){ zeige(i + 1); });

  

  var slot = document.querySelector('.pd-thumb[data-var-slot]');
  function slotIndex(){ return slot ? thumbs.indexOf(slot) : -1; }
  if (slot){
    document.addEventListener('change', function(ev){
      var r = ev.target;
      if (!r || r.name !== 'gebinde' || !r.checked || !r.dataset.bild) return;
      if (slot.dataset.src !== r.dataset.bild){
        slot.dataset.src = r.dataset.bild;
         
        delete slot.dataset.srcset;
        if (r.dataset.bildAlt){
          slot.dataset.alt = r.dataset.bildAlt;
          slot.setAttribute('aria-label', r.dataset.bildAlt);
        }
        var kachel = slot.querySelector('img');
        if (kachel && r.dataset.bildKlein) kachel.src = r.dataset.bildKlein;
      }
      

      if (slotIndex() > -1) zeige(slotIndex());
    });
  }

   
  if (thumbs.length < 2){
    [zurueck, vor, zaehler].forEach(function(e){ if (e) e.remove(); });
    return;
  }
  

  zeige(slotIndex() > -1 ? slotIndex() : 0);
})();



(function(){
  var wurzeln = document.querySelectorAll('[data-farbton]');
  if (!wurzeln.length) return;

  

  var ZULAGE = {};
  (function(){
    var gq = document.querySelector('[data-zulage-groessen]');
    if (gq){ try { JSON.parse(gq.getAttribute('data-zulage-groessen')).forEach(function(k){ ZULAGE[String(k)] = {}; }); } catch (e) {} }
    var pq = document.querySelector('script[data-zulage-preise]');
    if (pq){ try { var pz = JSON.parse(pq.textContent); Object.keys(pz).forEach(function(k){ ZULAGE[k] = pz[k]; }); } catch (e) {} }
  })();

  var zustand = {modus:'getoent', ton:null};  
  var abos = [];

  

  var SYSTEM = wurzeln[0].dataset.tonSystem || '';
  var liste = null, listeLauf = null;
  function laden(){
    if (liste) return Promise.resolve(liste);
    if (!listeLauf) listeLauf = fetch(wurzeln[0].dataset.wunsch)
      .then(function(r){ if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function(j){
        liste = ((j.systeme || {})[SYSTEM] || []).map(function(x){
          return {c:x[0], b:x[1], h:x[2] || null, n:norm(x[0])};
        });
        return liste;
      })
      .catch(function(e){ listeLauf = null; throw e; });
    return listeLauf;
  }

  var norm = function(s){ return s.toUpperCase().replace(/[^A-Z0-9]+/g, ''); };

  

  function basisSetzen(b){
    if (!b) return;
    var knopf = null;
    document.querySelectorAll('.pd-sorte-btn').forEach(function(x){
      if (x.dataset.wert === materea_t("js.pdp.basis",{b:b})) knopf = x;
    });
    if (knopf && knopf.getAttribute('aria-pressed') !== 'true') knopf.click();
  }

  function male(){
    wurzeln.forEach(function(w){
      w.querySelectorAll('.pd-ton-mbtn').forEach(function(b){
        b.setAttribute('aria-pressed', String(b.dataset.modus === zustand.modus));
      });
      var wahl = w.querySelector('.pd-ton-wahl');
      if (wahl) wahl.hidden = zustand.modus !== 'getoent';
      var anz = w.querySelector('[data-ton-anzeige]');
      if (anz){
        anz.hidden = !zustand.ton;
        if (zustand.ton){
          anz.querySelector('[data-ton-code]').textContent = zustand.ton.code;
          var sw = anz.querySelector('[data-ton-swatch]');
          if (zustand.ton.hex) sw.style.setProperty('--tonhex', zustand.ton.hex);
          else sw.style.removeProperty('--tonhex');
          sw.hidden = !zustand.ton.hex;
          var bas = anz.querySelector('[data-ton-basis]');
          if (bas){
            bas.hidden = !zustand.ton.basis;
            bas.textContent = zustand.ton.basis ? materea_t("js.pdp.basis",{b:zustand.ton.basis}) : '';
          }
        }
      }
      w.querySelectorAll('.pd-ton-chip, .pd-ton-sw').forEach(function(c){
        c.setAttribute('aria-pressed', String(!!zustand.ton && c.dataset.code === zustand.ton.code));
      });
      var fehlt = w.querySelector('[data-fehlt]');
      if (fehlt) fehlt.hidden = true;
    });
  }

  function setze(neu){
    if ('modus' in neu) zustand.modus = neu.modus;
    if ('ton' in neu) zustand.ton = neu.ton;
    male();
    if (neu.ton && neu.ton.basis) basisSetzen(neu.ton.basis);
    abos.forEach(function(f){ f(); });
  }

  var MAX = 60;
  function gridMalen(w, treffer, hinweis){
    var panel = w.querySelector('[data-panel="code"]');
    var grid = panel.querySelector('[data-grid]');
    var mitBasis = !!document.querySelector('.pd-sorte-btn[data-wert="' + materea_t("js.pdp.basis",{b:"A"}) + '"], .pd-sorte-btn[data-wert="' + materea_t("js.pdp.basis",{b:"B"}) + '"]');
    grid.innerHTML = treffer.slice(0, MAX).map(function(t){
      var c = t.c.replace(/"/g, '&quot;');
      return '<button type="button" class="pd-ton-sw" data-code="' + c + '" data-basis="' + t.b + '"' +
        (t.h ? ' style="--tonhex:' + t.h + '"' : '') +
        ' title="' + c + '" aria-label="' + c + (mitBasis ? materea_t("js.pdp.basis_komma",{b:t.b}) : '') + '" aria-pressed="' +
        (zustand.ton && zustand.ton.code === t.c ? 'true' : 'false') +
        '"><i aria-hidden="true"></i><span>' + t.c.replace(/^NCS S /, '').replace(/^Farrow & Ball /, '') +
        (mitBasis ? '<small>' + materea_t("js.pdp.basis",{b:t.b}) + '</small>' : '') + '</span></button>';
    }).join('');
    var status = panel.querySelector('[data-status]');
    if (status) status.textContent = hinweis ||
      (treffer.length > MAX ? materea_t("js.pdp.zeige_treffer",{max:MAX,n:treffer.length})
                            : treffer.length + (treffer.length === 1 ? materea_t("js.pdp.ton") : materea_t("js.pdp.toene")));
  }

  function freiKnopf(w, wert){
    var roh = wert.replace(/\s+/g, ' ').trim().slice(0, 60);
    var status = w.querySelector('[data-panel="code"] [data-status]');
    if (!roh || !status) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pd-ton-frei';
    b.setAttribute('data-frei', roh);
    b.textContent = materea_t("js.pdp.ton_frei_uebernehmen",{code:roh});
    status.appendChild(b);
  }

  function suchen(w, wert){
    var s = norm(wert.replace(/^\s*NCS\s*S?\s*/i, ''));
    if (s.length < 2) return gridMalen(w, [], materea_t("js.pdp.tipp_code"));
    laden().then(function(l){
      var vorn = [], rest = [];
      l.forEach(function(t){
        var i = t.n.indexOf(s);
        if (i === -1) return;
        var kern = t.n.replace(/^NCSS|^RAL|^FARROWBALL/, '');
        (kern.indexOf(s) === 0 || i === 0 ? vorn : rest).push(t);
      });
      var tr = vorn.concat(rest);
      if (!tr.length){
        gridMalen(w, [], materea_t("js.pdp.ton_fehlt"));
        return freiKnopf(w, wert);
      }
      gridMalen(w, tr);
    }).catch(function(){
      gridMalen(w, [], materea_t("js.pdp.farbliste_fehler"));
    });
  }

  wurzeln.forEach(function(w){
    w.addEventListener('click', function(ev){
      var el = ev.target.closest('button');
      if (!el || !w.contains(el)) return;
      if (el.dataset.modus) return setze({modus: el.dataset.modus});
      if (el.hasAttribute('data-ton-weg')) return setze({ton: null});
      if (el.dataset.frei) return setze({ton: {code: el.dataset.frei, hex: null, basis: null, frei: true}});
      if (el.dataset.sys){
        w.querySelectorAll('.pd-ton-sysbtn').forEach(function(b){
          b.setAttribute('aria-pressed', String(b.dataset.sys === el.dataset.sys));
        });
        w.querySelectorAll('.pd-ton-panel').forEach(function(p){
          p.hidden = p.dataset.panel !== el.dataset.sys;
        });
        if (el.dataset.sys === 'code'){
          laden().catch(function(){});
          var f = w.querySelector('[data-wunsch-input]');
          if (f) f.focus();
        }
        return;
      }
      if (el.classList.contains('pd-ton-chip') || el.classList.contains('pd-ton-sw')){
        var hex = (el.style.getPropertyValue('--tonhex') || '').trim();
        return setze({ton: {code: el.dataset.code, hex: hex || null, basis: el.dataset.basis || null}});
      }
    });
    var feld = w.querySelector('[data-wunsch-input]');
    if (feld){
      var t = null;
      feld.addEventListener('input', function(){
        clearTimeout(t);
        t = setTimeout(function(){ suchen(w, feld.value); }, 140);
      });
      feld.addEventListener('keydown', function(ev){
        if (ev.key !== 'Enter') return;
        ev.preventDefault();
        var erste = w.querySelectorAll('[data-panel="code"] .pd-ton-sw');
        if (erste.length === 1) erste[0].click();
        else if (!erste.length){
          var frei = w.querySelector('[data-frei]');
          if (frei) frei.click();
        }
      });
    }
  });

  window.MatereaFarbton = {
    ZULAGE: ZULAGE,
    aktiv: function(){ return zustand.modus === 'getoent'; },
    ton: function(){ return zustand.ton; },
    tonText: function(){ return zustand.modus === 'ungetoent' ? 'Ungetönt' : (zustand.ton ? zustand.ton.code + (zustand.ton.frei ? ' (nicht in der Liste, wird geprüft)' : '') + (zustand.ton.basis ? ' (Basis ' + zustand.ton.basis + ')' : '') : null); },
    pruefe: function(){
      if (zustand.modus === 'getoent' && !zustand.ton){
        wurzeln.forEach(function(w){
          var f = w.querySelector('[data-fehlt]');
          if (f) f.hidden = false;
        });
        return false;
      }
      return true;
    },
    abo: function(f){ abos.push(f); }
  };
})();



(function(){
  var fmt = function(n){ return n.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}); };
  var preisNote = (function(){ var s = document.querySelector('#pd-price small'); return s ? s.textContent : ''; })();

  

  function werk(){
    var r = document.querySelector('input[name="gebinde"]:checked');
    return !!(r && (r.dataset.familie || '').indexOf(materea_t("js.pdp.werkstoenung")) !== -1);
  }
  function tonGate(){
    var w = werk();
    document.querySelectorAll('[data-farbton]').forEach(function(el){ el.hidden = w; });
  }

  var radios = document.querySelectorAll('input[name="gebinde"]');
  radios.forEach(function(r){
    r.addEventListener('change', function(){
      if (!r.checked) return;
      var el, kg = parseFloat(r.dataset.kg);
      tonGate();
      if (r.dataset.preis){
        var preis = parseFloat(r.dataset.preis) / 100;
        if ((el = document.getElementById('pd-price'))) el.innerHTML = fmt(preis) + '&nbsp;€<small></small>';
        if (el && el.querySelector('small')) el.querySelector('small').textContent = preisNote;
        if ((el = document.getElementById('pd-grund')) && kg > 0) el.textContent = fmt(preis / kg) + materea_t("js.pdp.je") + (r.dataset.einheit || 'kg');
        if ((el = document.getElementById('pd-sticky-preis'))) el.innerHTML = fmt(preis) + '&nbsp;€ netto' + (r.dataset.reich ? ' &middot; ' + r.dataset.reich : '');
      }
      if (r.dataset.bild && (el = document.getElementById('pd-gal-img')) && el.src !== r.dataset.bild){
        el.src = r.dataset.bild;
        el.removeAttribute('style');
        document.querySelectorAll('.pd-thumb[aria-current]').forEach(function(t){ t.removeAttribute('aria-current'); });
      }
      if ((el = document.getElementById('pd-sku'))) el.textContent = r.value;
      if ((el = document.getElementById('pd-reich'))) el.textContent = r.dataset.reich || '';
      if ((el = document.getElementById('pd-reich-out'))) el.textContent = r.dataset.reich || '';
      zulageZeile();
    });
  });

  

  function zulageZeile(){
    var line = document.getElementById('pd-zul-line');
    var MF = window.MatereaFarbton;
    if (!line || !MF) return;
    var r = document.querySelector('input[name="gebinde"]:checked');
    var z = r && r.dataset.kg ? MF.ZULAGE[String(parseFloat(r.dataset.kg))] : null;
    var hat = z && typeof z.preis === 'number' && !werk();
    line.hidden = !MF.aktiv() || !hat;
    if (hat) document.getElementById('pd-zul-preis').innerHTML = fmt(z.preis) + '&nbsp;€';
    var echo = document.getElementById('pd-mecho-getoent');
    if (echo) echo.innerHTML = hat ? '+&nbsp;' + fmt(z.preis) + '&nbsp;€ je Gebinde' : '';
  }
  if (window.MatereaFarbton) window.MatereaFarbton.abo(zulageZeile);
  zulageZeile();
  tonGate();

   
  var varSelect = document.getElementById('pd-var-select');
  if (varSelect){
    varSelect.addEventListener('change', function(){
      var r = document.querySelector('input[name="gebinde"][data-variant-id="' + varSelect.value + '"]');
      if (!r) return;
      r.checked = true;
      r.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }

  

  function sorteFilter(){
    var btns = document.querySelectorAll('.pd-sorte-btn[aria-pressed="true"]');
    if (!btns.length) return;
    var wahl = {};
    btns.forEach(function(b){ wahl[b.dataset.optPos] = b.dataset.wert; });
    var sichtbar = [];
    document.querySelectorAll('.pd-var-row').forEach(function(row){
      var r = row.querySelector('input[name="gebinde"]');
      if (!r) return;
      var ok = true;
      Object.keys(wahl).forEach(function(pos){ if (r.dataset['o' + pos] !== wahl[pos]) ok = false; });
      row.hidden = !ok;
      if (ok) sichtbar.push(r);
    });
    var akt = document.querySelector('input[name="gebinde"]:checked');
    if ((!akt || akt.closest('.pd-var-row').hidden) && sichtbar.length){
      var ziel = null;
      sichtbar.forEach(function(r){ if (!ziel && !r.disabled) ziel = r; });
      ziel = ziel || sichtbar[0];
      ziel.checked = true;
      ziel.dispatchEvent(new Event('change', {bubbles: true}));
    }
  }
  document.querySelectorAll('.pd-sorte-btn').forEach(function(b){
    b.addEventListener('click', function(){
      document.querySelectorAll('.pd-sorte-btn[data-opt-pos="' + b.dataset.optPos + '"]').forEach(function(x){
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      sorteFilter();
    });
  });
  sorteFilter();

   
  var wahlBox = document.querySelector('[data-wahl]');
  if (wahlBox) wahlBox.querySelectorAll('.pd-wahl-btn').forEach(function(b){
    b.addEventListener('click', function(){
      wahlBox.querySelectorAll('.pd-wahl-btn').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      wahlBox.querySelector('[data-wahl-fehlt]').hidden = true;
    });
  });

  

  var atc = document.getElementById('pd-atc');
  if (atc) atc.addEventListener('click', function(){
    var MF = window.MatereaFarbton;
    var korb = document.getElementById('pd-atc-korb');
    if (!korb) return;
    if (MF && !werk() && !MF.pruefe()){
      korb.hidden = false;
      korb.textContent = materea_t("js.pdp.farbton_zuerst");
      return;
    }
    var r = document.querySelector('input[name="gebinde"]:checked');
    if (!r || !r.dataset.variantId) return;
    var n = parseInt(document.getElementById('pd-qty').value, 10) || 1;
    var props = (MF && !werk() && MF.tonText()) ? {'Farbton': MF.tonText()} : null;
    var items = [{id: parseInt(r.dataset.variantId, 10), quantity: n}];
    if (props) items[0].properties = {'Farbton': props.Farbton};
    if (wahlBox){
      var gew = wahlBox.querySelector('.pd-wahl-btn[aria-pressed="true"]');
      if (!gew){
        wahlBox.querySelector('[data-wahl-fehlt]').hidden = false;
        wahlBox.scrollIntoView({block: 'center', behavior: 'smooth'});
        return;
      }
      items[0].properties = items[0].properties || {};
      items[0].properties[wahlBox.dataset.wahlLabel] = gew.dataset.wert;
    }
    var z = (MF && !werk() && MF.aktiv() && r.dataset.kg) ? MF.ZULAGE[String(parseFloat(r.dataset.kg))] : null;
    if (z && z.id){
      var zi = {id: z.id, quantity: n};
      zi.properties = props ? {'Farbton': props.Farbton, '_zu': String(items[0].id)} : {'_zu': String(items[0].id)};
      items.push(zi);
    }
    korb.hidden = false;
    korb.textContent = materea_t("js.pdp.wird_gelegt");
    fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart/add.js", {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: items})})
      .then(function(res){
        if (!res.ok) return res.json().catch(function(){ return {}; }).then(function(j){ throw new Error(j.description || j.message || ('HTTP ' + res.status)); });
        return res.json();
      })
      .then(function(){
        korb.innerHTML = 'Im Warenkorb. <a href="/cart">Zum Warenkorb&nbsp;&#8594;</a>';
        document.dispatchEvent(new CustomEvent('materea:korb', {detail: {neu: items.map(function(i){ return String(i.id); })}}));
      })
      .catch(function(e){ korb.textContent = materea_t("js.pdp.korb_fehler") + e.message; });
  });

  

  var satc = document.getElementById('pd-sticky-atc');
  if (satc && atc) satc.addEventListener('click', function(){
    var zone = document.getElementById('produkt');
    if (zone) zone.scrollIntoView({block: 'start', behavior: 'auto'});
    atc.click();
  });
})();



(function(){
  var form = document.getElementById('pd-calc');
  if (!form) return;
  var fmt = function(n){ return n.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}); };
  var EINHEIT = form.dataset.einheit || 'kg';
  var kgTxt = function(n){ return n.toLocaleString(materea_t("js.pdp.zahlformat")) + ' ' + EINHEIT; };
  var LAGEN = form.dataset.lagen || materea_t("js.pdp.zwei_lagen");
  var TOENBAR = form.dataset.toenbar === '1';
  var MF = window.MatereaFarbton;
  var ZULAGE = (MF || {}).ZULAGE || {};

  

  var KOERN = null;
  try { KOERN = JSON.parse(form.dataset.koernungen || 'null'); } catch (e) { KOERN = null; }
  if (KOERN && !Object.keys(KOERN).length) KOERN = null;
  

  var KPOS = parseInt(form.dataset.koernPos, 10);
  var GPOS = parseInt(form.dataset.gebPos, 10);
  function optWert(r, i){ return (r && r.dataset['o' + i]) || ''; }
  function koernVon(r){
    return (KOERN && !isNaN(KPOS)) ? optWert(r, KPOS) : (r.dataset.familie || null);
  }
  function restVon(r){
    return [0, 1, 2].filter(function(i){ return i !== KPOS && i !== GPOS; })
      .map(function(i){ return optWert(r, i); }).join('|');
  }

  function checkedRadio(){ return document.querySelector('input[name="gebinde"]:checked'); }
  function vgAktiv(){
    var r = checkedRadio();
    if (r && r.dataset.vg) return parseFloat(r.dataset.vg);
    return parseFloat(form.dataset.verbrauch);
  }

  function lagenAnz(){
    return form.querySelectorAll('.pd-lage-zeile:not([hidden])').length;
  }
  function lagenWahl(){
    return Array.prototype.map.call(form.querySelectorAll('.pd-lage-zeile:not([hidden]) .pd-lage-wahl'), function(g){
      var b = g.querySelector('.pd-lage-btn[aria-pressed="true"]');
      return b ? b.dataset.koern : null;
    }).filter(function(k){ return k && KOERN[k] > 0; });
  }
  function lagenTxt(){
    var n = lagenAnz();
    if (n === 0 || n >= (parseInt(form.dataset.lagenzahl, 10) || 2)) return LAGEN;
    return n === 1 ? materea_t("js.pdp.einer_lage") : materea_t("js.pdp.n_lagen",{n:materea_t("js.pdp.zahlworte").split(",")[n]});
  }

  

  function bedarf(m2){
    if (!KOERN) {
      var vg = vgAktiv();
      

      var zahl = parseInt(form.dataset.lagenzahl, 10) || 2, n = lagenAnz();
      if (n > 0 && n < zahl) vg = vg / zahl * n;
      return vg > 0 ? [{koern:null, kg:m2 * vg}] : [];
    }
    var w = lagenWahl();
    if (!w.length) return [];
    var reihe = [], idx = {};
    w.forEach(function(k){
      if (idx[k] === undefined){ idx[k] = reihe.length; reihe.push({koern:k, kg:0}); }
      reihe[idx[k]].kg += m2 * KOERN[k];
    });
    return reihe;
  }

  

  function werk(){
    var r = checkedRadio();
    return !!(r && (r.dataset.familie || '').indexOf(materea_t("js.pdp.werkstoenung")) !== -1);
  }
  if (werk()) document.querySelectorAll('[data-farbton]').forEach(function(el){ el.hidden = true; });

  

  function rohdaten(){
    var radios = document.querySelectorAll('input[name="gebinde"]');
    if (!radios.length) return [];
    var fam = (checkedRadio() || {dataset: {}}).dataset.familie || '';
    var rest = restVon(checkedRadio());
    return Array.prototype.filter.call(radios, function(r){
      

      if (r.disabled) return false;
      return KOERN ? restVon(r) === rest : (r.dataset.familie || '') === fam;
    }).map(function(r){
      return {sku: r.value, id: r.dataset.variantId, kg: r.dataset.kg, inhalt: r.dataset.inhalt, preis: r.dataset.preis,
              koern: koernVon(r)};
    });
  }

  function gebinde(koern){
    return rohdaten().map(function(r){
      var kg = parseFloat(r.kg);
      return {sku: String(r.sku), id: r.id, kg: kg, inhalt: parseFloat(r.inhalt) || kg, koern: r.koern || null,
              preis: r.preis ? parseFloat(r.preis) / 100 : 0,
              zulage: ZULAGE[String(kg)] || null};
    }).filter(function(g){
      if (!(g.kg > 0)) return false;
      

      return !koern || !g.koern || g.koern === koern;
    }).sort(function(a, b){
      return b.kg - a.kg;
    });
  }

  

  function kombination(kgNoetig, liste, mitZulage){
    var kleinstes = liste.reduce(function(m, g){ return Math.min(m, g.kg); }, Infinity);
    var stueckaufschlag = isFinite(kleinstes) ? kleinstes / 2 : 0;
    var kosten = liste.map(function(g){
      var basis = g.preis > 0 ? g.preis : g.kg + stueckaufschlag;
      return basis + (mitZulage && g.zulage && typeof g.zulage.preis === 'number' ? g.zulage.preis : 0);
    });
    var mengen = liste.map(function(){ return 0; });
    var best = null;
    (function rek(i, rest, summe){
      if (best && summe >= best.summe) return;
      if (rest <= 0.0001){ best = {summe: summe, mengen: mengen.slice()}; return; }
      if (i >= liste.length) return;
      for (var n = Math.ceil(rest / liste[i].inhalt - 0.0001); n >= 0; n--){
        mengen[i] = n;
        rek(i + 1, rest - n * liste[i].inhalt, summe + n * kosten[i]);
      }
      mengen[i] = 0;
    })(0, kgNoetig, 0);
    return best;
  }

  function teileTxt(liste, mengen){
    var t = [];
    liste.forEach(function(g, i){ if (mengen[i]) t.push(mengen[i] + '× ' + kgTxt(g.kg)); });
    return t.join(' + ');
  }

  var letzte = [];

  

  function ausgabeLeeren(){
    letzte = [];
    var el;
    if ((el = document.getElementById('pd-calc-zul'))) el.textContent = '';
    if ((el = document.getElementById('pd-sum-mat'))) el.innerHTML = '';
    if ((el = document.getElementById('pd-sum-zul'))) el.innerHTML = '';
    if ((el = document.getElementById('pd-sum-ges'))) el.innerHTML = '';
  }

  function rechne(){
    var m2 = parseFloat(document.getElementById('pd-m2').value);
    var erg = document.getElementById('pd-calc-erg');
    var det = document.getElementById('pd-calc-det');
    

    if (!(m2 >= 1)) {
      erg.textContent = materea_t("js.pdp.flaeche_eingeben");
      det.textContent = '';
      ausgabeLeeren();
      return;
    }
    if (m2 > 500) {
      erg.textContent = materea_t("js.pdp.flaeche_eingeben");
      det.textContent = materea_t("js.pdp.groessere_flaechen");
      ausgabeLeeren();
      return;
    }
    var posten = bedarf(m2);
    if (!posten.length) {
      erg.textContent = KOERN
        ? materea_t("js.pdp.koernung_waehlen")
        : materea_t("js.pdp.kein_rechenwert");
      det.textContent = '';
      ausgabeLeeren();
      return;
    }
    var mitZulage = TOENBAR && !werk() && (!MF || MF.aktiv());

    

    var mat = 0, zul = 0, ohneZulage = [], preiseDa = true;
    var ergT = [], detT = [], gesamtKg = 0, einKoern = '';
    letzte = [];
    posten.forEach(function(po){
      var liste = gebinde(po.koern);
      if (!liste.length) return;
      var k = kombination(po.kg, liste, mitZulage);
      if (!k) return;
      liste.forEach(function(g, i){
        if (!k.mengen[i]) return;
        if (!(g.preis > 0)) preiseDa = false;
        mat += k.mengen[i] * g.preis;
        if (!mitZulage) return;
        if (g.zulage && typeof g.zulage.preis === 'number') zul += k.mengen[i] * g.zulage.preis;
        else if (!g.zulage && ohneZulage.indexOf(kgTxt(g.kg)) < 0) ohneZulage.push(kgTxt(g.kg));
      });
      letzte.push({liste: liste, mengen: k.mengen, koern: po.koern, mitZulage: mitZulage});
      var vor = (po.koern && posten.length > 1) ? po.koern + ' ' : '';
      ergT.push(vor + teileTxt(liste, k.mengen));
      detT.push((Math.round(po.kg * 10) / 10).toLocaleString(materea_t("js.pdp.zahlformat")) + ' ' + EINHEIT
                + (po.koern && posten.length > 1 ? ' ' + po.koern.toLowerCase() : ''));
      if (po.koern && posten.length === 1) einKoern = po.koern.toLowerCase();
      gesamtKg += po.kg;
    });
    if (!letzte.length) {
      erg.textContent = materea_t("js.pdp.kein_rechenwert");
      det.textContent = '';
      ausgabeLeeren();
      return;
    }

    erg.textContent = materea_t("js.pdp.fuer") + m2.toLocaleString(materea_t("js.pdp.zahlformat")) + ' m²: ' + ergT.join(' · ');
    det.innerHTML = detT.length > 1
      ? materea_t("js.pdp.das_sind") + detT.join(materea_t("js.pdp.b_und_b")) + materea_t("js.pdp.b_zusammen")
        + (Math.round(gesamtKg * 10) / 10).toLocaleString(materea_t("js.pdp.zahlformat")) + ' ' + EINHEIT + materea_t("js.pdp.fuer_leer") + lagenTxt() + '.'
      : materea_t("js.pdp.das_sind") + detT[0] + materea_t("js.pdp.b_material")
        + (einKoern ? (lagenAnz() === 1 ? materea_t("js.pdp.eine_lage_komma") : materea_t("js.pdp.beide_lagen_komma")) + einKoern + '.' : materea_t("js.pdp.bei_leer") + lagenTxt() + '.');

     
    var mitH = null;
    letzte.forEach(function(t){ t.liste.forEach(function(g, i){ if (!mitH && t.mengen[i] && g.inhalt !== g.kg) mitH = g; }); });
    if (mitH) det.innerHTML += materea_t("js.pdp.haerter_eingerechnet") + kgTxt(mitH.kg) + materea_t("js.pdp.ergibt")
      + kgTxt(mitH.inhalt) + materea_t("js.pdp.fertiges_material");

    var zulZeile = document.getElementById('pd-calc-zul');
    if (!TOENBAR) {
      zulZeile.textContent = '';
    } else if (!mitZulage) {
      zulZeile.textContent = materea_t("js.pdp.ungetoent_gerechnet");
    } else if (ohneZulage.length) {
      

      zulZeile.textContent = materea_t("js.pdp.fuer") + ohneZulage.join(materea_t("js.gemeinsam.und")) + materea_t("js.pdp.keine_zulage");
    } else {
      zulZeile.textContent = materea_t("js.pdp.zulage_groessen")
        + letzte.map(function(teil){
            var vor = (teil.koern && letzte.length > 1) ? teil.koern + ' ' : '';
            return vor + teileTxt(teil.liste, teil.mengen);
          }).join(' · ') + '.';
    }

    var el;
    if ((el = document.getElementById('pd-sum-mat'))) el.innerHTML = preiseDa ? fmt(mat) + '&nbsp;€' : '';
    if ((el = document.getElementById('pd-sum-zul'))) el.innerHTML = fmt(zul) + '&nbsp;€';
    if ((el = document.getElementById('pd-sum-zul-zeile'))) el.hidden = !mitZulage;
    if ((el = document.getElementById('pd-sum-ges'))) el.innerHTML = preiseDa ? fmt(mat + zul) + '&nbsp;€ netto' : '';

    var korb = document.getElementById('pd-calc-korb');
    if (korb){ korb.hidden = true; korb.textContent = ''; }
  }

  

  function positionen(){
    var p = [];
    letzte.forEach(function(teil){
      var zu = (teil.koern && letzte.length > 1) ? ' ' + teil.koern : '';
      teil.liste.forEach(function(g, i){
        var n = teil.mengen[i];
        if (!n || !g.id) return;
        p.push({id: parseInt(g.id, 10), menge: n, name: kgTxt(g.kg) + zu});
        

        if (teil.mitZulage && g.zulage && g.zulage.id) p.push({id: g.zulage.id, menge: n, name: materea_t("js.pdp.zulage_name") + kgTxt(g.kg) + zu, zu: parseInt(g.id, 10)});
      });
    });
    return p;
  }

  form.addEventListener('submit', function(ev){ ev.preventDefault(); rechne(); });
  if (MF) MF.abo(rechne);
  document.addEventListener('change', function(ev){
    if (ev.target && ev.target.name === 'gebinde') rechne();
  });

   
  form.querySelectorAll('.pd-lage-wahl').forEach(function(gruppe){
    gruppe.addEventListener('click', function(ev){
      var b = ev.target.closest('.pd-lage-btn');
      if (!b) return;
      gruppe.querySelectorAll('.pd-lage-btn').forEach(function(x){
        x.setAttribute('aria-pressed', String(x === b));
      });
      rechne();
      feinWarnZeigen();
    });
  });

  

  var lagePlus = document.getElementById('pd-lage-plus');
  function lagePlusZeigen(){
    if (lagePlus) lagePlus.hidden = !form.querySelector('.pd-lage-zeile[hidden]');
  }
  lagePlusZeigen();
  if (lagePlus) lagePlus.addEventListener('click', function(){
    var z = form.querySelector('.pd-lage-zeile[hidden]');
    if (!z) return;
    z.hidden = false;
    lagePlusZeigen();
    rechne();
  });
  form.querySelectorAll('.pd-lage-weg').forEach(function(b){
    b.addEventListener('click', function(){
      b.closest('.pd-lage-zeile').hidden = true;
      lagePlusZeigen();
      rechne();
    });
  });

  

  var ersteGrob = form.dataset.ersteGrob === '1';
  var feinWarn = document.getElementById('pd-lage-warn');
  var feinDlg = document.getElementById('pd-feinfein');
  var feinOk = false;
  function ersteLageWahl(){
    var z = form.querySelector('.pd-lage-zeile .pd-lage-wahl');
    return z ? z.querySelector('.pd-lage-btn[aria-pressed="true"]') : null;
  }
  function ersteLageFein(){
    var b = ersteLageWahl();
    return ersteGrob && !!b && b.dataset.koern === form.dataset.kfein;
  }
  function feinWarnZeigen(){
    var fein = ersteLageFein();
    if (feinWarn) feinWarn.hidden = !fein;
    if (!fein) feinOk = false;
  }
  function feinFeinFragen(){
    if (!ersteLageFein() || feinOk || !feinDlg || typeof feinDlg.showModal !== 'function') return false;
    feinDlg.showModal();
    return true;
  }
  if (feinDlg){
    feinDlg.querySelector('[data-grob]').addEventListener('click', function(){
      var z = form.querySelector('.pd-lage-zeile .pd-lage-wahl');
      var g = z ? z.querySelector('.pd-lage-btn[data-koern="' + form.dataset.kgrob + '"]') : null;
      if (g) g.click();
      feinDlg.close();
      var k = document.getElementById('pd-calc-korb');
      if (k){ k.hidden = false; k.textContent = materea_t("js.pdp.erste_lage_grob"); }
    });
    feinDlg.querySelector('[data-fein]').addEventListener('click', function(){
      feinOk = true;
      feinDlg.close();
      if (atc) atc.click();
    });
  }
  feinWarnZeigen();

  var atc = document.getElementById('pd-calc-atc');
  if (atc) atc.addEventListener('click', function(){
    var korb = document.getElementById('pd-calc-korb');
    if (feinFeinFragen()) return;
    if (MF && !werk() && !MF.pruefe()){
      korb.hidden = false;
      korb.textContent = materea_t("js.pdp.farbton_zuerst");
      return;
    }
    var p = positionen();
    if (!p.length) return;
    var props = (MF && !werk() && MF.tonText()) ? {'Farbton': MF.tonText()} : null;
    var items = p.map(function(x){
      var it = {id: x.id, quantity: x.menge};
      if (props) it.properties = {'Farbton': props.Farbton};
      if (x.zu){ it.properties = it.properties || {}; it.properties['_zu'] = String(x.zu); }
      return it;
    });
    korb.hidden = false;
    korb.textContent = materea_t("js.pdp.wird_gelegt");
    fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/")+"cart/add.js", {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: items})})
      .then(function(res){
        if (!res.ok) return res.json().catch(function(){ return {}; }).then(function(j){ throw new Error(j.description || j.message || ('HTTP ' + res.status)); });
        return res.json();
      })
      .then(function(){
        korb.innerHTML = 'Im Warenkorb. <a href="/cart">Zum Warenkorb&nbsp;&#8594;</a>';
        document.dispatchEvent(new CustomEvent('materea:korb', {detail: {neu: items.map(function(i){ return String(i.id); })}}));
      })
      .catch(function(e){ korb.textContent = materea_t("js.pdp.korb_fehler") + e.message; });
  });

  rechne();
})();

 
(function(){
  var qty = document.getElementById('pd-qty');
  if (qty) {
    document.querySelectorAll('.pd-step-btn').forEach(function(b){
      b.addEventListener('click', function(){
        var v = parseInt(qty.value, 10) || 1;
        qty.value = Math.min(99, Math.max(1, v + parseInt(b.dataset.d, 10)));
      });
    });
    qty.addEventListener('change', function(){
      var v = parseInt(qty.value, 10) || 1;
      qty.value = Math.min(99, Math.max(1, v));
    });
  }
  var copy = document.getElementById('pd-copy');
  if (copy && navigator.clipboard) {
    copy.addEventListener('click', function(){
      navigator.clipboard.writeText(document.getElementById('pd-sku').textContent).then(function(){
        copy.textContent = materea_t("js.pdp.kopiert");
        setTimeout(function(){ copy.textContent = materea_t("js.pdp.kopieren"); }, 1600);
      });
    });
  }
})();



(function(){
  var zone = document.querySelector('.pd-price-zone');
  var bar = document.getElementById('pd-sticky');
  if (!zone || !bar) return;
  function check(){
    bar.classList.toggle('an', zone.getBoundingClientRect().bottom < 0);
  }
  addEventListener('scroll', check, {passive:true});
  addEventListener('resize', check, {passive:true});
  addEventListener('hashchange', check);
   
  addEventListener('load', check);
  setTimeout(check, 300);
  check();
})();


(function () {
  var dlg = document.getElementById('pd-anf');
  var form = document.getElementById('pd-anf-form');
  if (!dlg || !form) return;

  var box = dlg.querySelector('.pd-anf-box');
  var fuss = form.querySelector('.pd-anf-fuss');
  var fehler = form.querySelector('[data-anf-fehler]');
  var knopf = form.querySelector('[data-anf-senden]');
  var knopfText = form.querySelector('[data-anf-cta-text]');
  var ok = dlg.querySelector('[data-anf-ok]');
  var okMail = dlg.querySelector('[data-anf-ok-mailweg]');
  var endpunkt = dlg.getAttribute('data-endpoint') || '';
  var mailAdresse = dlg.getAttribute('data-mail') || 'kontakt@materea.at';
  var produkt = dlg.getAttribute('data-produkt') || '';
  var sku = dlg.getAttribute('data-sku') || '';
  var trigger = null;

   
  function kante() {
    fuss.classList.toggle('klebt', box.scrollTop + box.clientHeight < box.scrollHeight - 2);
  }
  box.addEventListener('scroll', kante, { passive: true });
  window.addEventListener('resize', kante);
  if (window.ResizeObserver) new ResizeObserver(kante).observe(form);

  function auf(e) {
    trigger = e.currentTarget;
    dlg.showModal();
    document.documentElement.classList.add('anf-offen');
    

    box.focus({ preventScroll: true });
    requestAnimationFrame(kante);
    setTimeout(kante, 360);
  }
  document.querySelectorAll('[data-anf-auf]').forEach(function (b) {
    b.addEventListener('click', auf);
  });
  dlg.querySelector('[data-anf-zu]').addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('close', function () {
    document.documentElement.classList.remove('anf-offen');
    fuss.classList.remove('klebt');
    if (trigger) trigger.focus({ preventScroll: true });
  });
  

  dlg.addEventListener('click', function (e) {
    if (e.detail === 0) return;
    var r = dlg.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
  });

  function zeigeDanke(perMail, adresse) {
    form.hidden = true;
    if (perMail) { okMail.hidden = false; }
    else {
      var ziel = ok.querySelector('[data-anf-ok-mail]');
      if (ziel) ziel.textContent = adresse;
      ok.hidden = false;
    }
  }

  function mailOk(s) { return /^[A-Za-z0-9._%+\-]+@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,}$/.test(s); }
   
  function telefonVoll(d) {
    var t = (d.telefon || '').replace(/[^0-9+ ]/g, ' ').replace(/\s+/g, ' ').trim();
    if (!t) return '';
    if (t.charAt(0) === '+') return t;
    if (t.indexOf('00') === 0) return '+' + t.slice(2);
    return (d.vorwahl || '+43') + ' ' + t.replace(/^0+/, '');
  }
  var mailFeld = form.elements.email;
  if (mailFeld) mailFeld.addEventListener('blur', function () {
    var v = mailFeld.value.trim();
    mailFeld.closest('.pd-anf-feld').classList.toggle('invalid', !!v && !mailOk(v));
  });
  var telFeld = form.elements.telefon, vorwahlFeld = form.elements.vorwahl;
  if (telFeld && vorwahlFeld && telFeld.value.charAt(0) === '+') {
    Array.prototype.slice.call(vorwahlFeld.options).sort(function (a, b) { return b.value.length - a.value.length; })
      .some(function (o) {
        if (telFeld.value.indexOf(o.value) !== 0) return false;
        vorwahlFeld.value = o.value;
        telFeld.value = telFeld.value.slice(o.value.length).trim();
        return true;
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var d = {};
    new FormData(form).forEach(function (v, k) { d[k] = String(v).trim(); });

    var pflicht = [['firma', materea_t("js.pdp.firma")], ['vorname', materea_t("js.pdp.vorname")], ['nachname', materea_t("js.pdp.nachname")], ['email', materea_t("js.pdp.email")]];
    var fehlt = [];
    pflicht.forEach(function (paar) {
      var feld = form.elements[paar[0]];
      var leer = !feld.value.trim() || (paar[0] === 'email' && !mailOk(feld.value.trim()));
      feld.closest('.pd-anf-feld').classList.toggle('invalid', leer);
      if (leer) fehlt.push(paar[1]);
    });
    if (fehlt.length) {
      fehler.textContent = materea_t("js.pdp.noch_ausfuellen") + fehlt.join(', ') + '.';
      fehler.hidden = false;
      var erstes = form.querySelector('.invalid input');
      if (erstes) erstes.focus();
      return;
    }
    fehler.hidden = true;
    if (d.ort_hp) { zeigeDanke(false, d.email); return; }

    var mass = (d.breite || '?') + ' x ' + (d.laenge || '?') + ' cm, ' + (d.stueck || '1') + ' Stück';

     
    if (!endpunkt) {
      fehler.innerHTML = materea_t("js.pdp.formular_weg")
        + '<a href="mailto:' + mailAdresse + '">' + mailAdresse + '</a>.';
      fehler.hidden = false;
      return;
    }

    knopf.disabled = true;
    if (knopfText) knopfText.textContent = materea_t("js.pdp.wird_gesendet");
    fetch(endpunkt, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        typ: 'produkt-anfrage', produkt: produkt, sku: sku,
        breite: d.breite, laenge: d.laenge, stueck: d.stueck,
        firma: d.firma, vorname: d.vorname, nachname: d.nachname,
        email: d.email, telefon: telefonVoll(d), nachricht: d.nachricht, ort_hp: d.ort_hp,
        seite: window.location.href
      })
    }).then(function (r) {
      if (r.status === 422) {
        return r.json().then(function (j) {
          var f = (j && j.fehler) || [];
          knopf.disabled = false;
          if (knopfText) knopfText.textContent = materea_t("js.pdp.anfrage_senden");
          var mailFalsch = f.indexOf('email') > -1 || f.indexOf('email_domain') > -1;
          if (mailFalsch) form.elements.email.closest('.pd-anf-feld').classList.add('invalid');
          if (f.indexOf('telefon') > -1) form.elements.telefon.closest('.pd-anf-feld').classList.add('invalid');
          fehler.textContent = mailFalsch
            ? materea_t("js.pdp.mail_falsch")
            : (f.indexOf('telefon') > -1 ? materea_t("js.pdp.telefon_pruefen") : materea_t("js.pdp.angaben_pruefen"));
          fehler.hidden = false;
        });
      }
      if (!r.ok) throw new Error(r.status);
      zeigeDanke(false, d.email);
    }).catch(function () {
      knopf.disabled = false;
      if (knopfText) knopfText.textContent = materea_t("js.pdp.anfrage_senden");
      fehler.innerHTML = materea_t("js.pdp.fehler_schreib")
        + '<a href="mailto:' + mailAdresse + '">' + mailAdresse + materea_t("js.pdp.selber_werktag");
      fehler.hidden = false;
    });
  });
})();




(function(){
  var buehnen = document.querySelectorAll('[data-pdp-video]');
  if (!buehnen.length) return;
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  buehnen.forEach(function(buehne){
    var video   = buehne.querySelector('[data-pdp-haupt]');
    var deckel  = buehne.querySelector('.p8-deckel');
    var schleife= buehne.querySelector('[data-pdp-schleife]');
    if (!video || !deckel) return;

    if (schleife && !ruhig) {
      var anwerfen = function(){
        if (buehne.classList.contains('spielt')) return;
        var los = schleife.play();
        if (los && los.catch) los.catch(function(){});
      };
      var zeigen = function(){ buehne.classList.add('vorschau'); anwerfen(); };
      if (schleife.readyState >= 3) zeigen();
      else schleife.addEventListener('canplay', zeigen, {once:true});
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(eintraege){
          eintraege.forEach(function(e){ e.isIntersecting ? anwerfen() : schleife.pause(); });
        }, {threshold:.15}).observe(buehne);
      }
      document.addEventListener('visibilitychange', function(){ if (!document.hidden) anwerfen(); });
    }

    

    var leiste = buehne.querySelector('[data-pdp-steuerung]');
    var knopf  = buehne.querySelector('[data-pdp-toggle]');
    var ton    = buehne.querySelector('[data-pdp-ton]');
    var uhr;

    var leisteZeigen = function(){
      if (!leiste || !buehne.classList.contains('spielt')) return;
      buehne.classList.add('zeigt');
      clearTimeout(uhr);
      if (video.paused) return;
      uhr = setTimeout(function(){
        if (!buehne.contains(document.activeElement)) buehne.classList.remove('zeigt');
      }, 2400);
    };

    var starten = function(){
      buehne.classList.add('spielt');
      if (leiste) leiste.hidden = false;
      if (schleife) schleife.pause();
      var los = video.play();
      if (los && los.catch) los.catch(function(){});
      leisteZeigen();
    };

    deckel.addEventListener('click', starten);

    if (knopf) knopf.addEventListener('click', function(){
      video.paused ? video.play() : video.pause();
    });
    if (ton) ton.addEventListener('click', function(){
      video.muted = !video.muted;
    });

     
    video.addEventListener('click', function(){
      if (!buehne.classList.contains('spielt')) return;
      video.paused ? video.play() : video.pause();
    });

    

    video.addEventListener('play', function(){
      buehne.classList.remove('pausiert');
      if (knopf) knopf.setAttribute('aria-label', materea_t("js.pdp.video_pausieren"));
      leisteZeigen();
    });
    video.addEventListener('pause', function(){
      buehne.classList.add('pausiert');
      if (knopf) knopf.setAttribute('aria-label', materea_t("js.pdp.video_abspielen"));
      buehne.classList.add('zeigt');
      clearTimeout(uhr);
    });
    video.addEventListener('volumechange', function(){
      buehne.classList.toggle('stumm', video.muted);
      if (ton) {
        ton.setAttribute('aria-label', video.muted ? materea_t("js.pdp.ton_ein") : materea_t("js.pdp.ton_aus"));
        ton.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
      }
    });

    buehne.addEventListener('pointermove', leisteZeigen);
    buehne.addEventListener('focusin', leisteZeigen);
    buehne.addEventListener('pointerleave', function(){
      if (!video.paused && !buehne.contains(document.activeElement)) buehne.classList.remove('zeigt');
    });

    video.addEventListener('ended', function(){
      buehne.classList.remove('spielt', 'zeigt', 'pausiert');
      if (leiste) leiste.hidden = true;
      video.currentTime = 0;
      if (schleife && !ruhig) schleife.play();
    });
  });
})();
